import { render, staticRenderFns } from "./PagesTable.vue?vue&type=template&id=356158ca"
import script from "./PagesTable.vue?vue&type=script&lang=js"
export * from "./PagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports